import { useTranslations } from "@shared/context/useTranslations";
import { Chip } from "@shared/components/Atoms/Chip/Chip.component";
import { PickupLocation } from "@shared/types/CategoryTypes.interface";
import { formatStock } from "@shared/helpers/formatStock";
import S from "./PickupLocationsModal.module.scss";

export const PickupLocationsModalContent = ({
    pickupLocations,
}: {
    pickupLocations: PickupLocation[];
}) => {
    const { getTranslation } = useTranslations();

    return (
        <div className={S.pickupLocationsModal}>
            {pickupLocations.map((location) => {
                const [street, ...rest] = location.address.split("\n");
                return (
                    <div key={location.id} className={S.pickupLocation}>
                        <div className={S.pickupLocationInfo}>
                            <h4 className={S.pickupLocationName}>{location.name}</h4>
                            <span className={S.pickupLocationStreet}>{street}</span>
                            <span className={S.pickupLocationAddress}>{rest.join("\n")}</span>
                        </div>
                        <Chip
                            size="small"
                            label={`${formatStock(location.quantity)} ${getTranslation("general.piece")}`}
                        />
                    </div>
                );
            })}
        </div>
    );
};
